import React, { Component, Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import "../../static/style/wp-content.css";

class NoOpenCases extends Component {
  render() {
    return (
      <Fragment>
        <div className="row">
          <div className="col-sm-12">
            <h1>
              <FormattedMessage
                id="app.not_found_debtor.title"
                defaultMessage="Ei avoimia tapauksia"
              />
            </h1>
            <p>
              <FormattedMessage
                id="app.not_found_debtor.description"
                defaultMessage="Emme löytäneet tiedoillasi avoimia tapauksia. Jos olet saanut meiltä laskun tai perintäkirjeen, niin otathan asiakaspalveluumme yhteyttä."
              />
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <p>
              <Link to={"/"} className={"btn btn-primary"}>
                <FormattedMessage
                  id="app.paymentsuccess.return"
                  defaultMessage="Palaa etusivulle"
                />
              </Link>
            </p>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default NoOpenCases;



// WEBPACK FOOTER //
// ./src/containers/static/NoOpenCases.js